import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo } from 'react';
import { useControlledState } from 'ariakit-utils/hooks';
/**
 * Provides state for the `Checkbox` component.
 * @see https://ariakit.org/components/checkbox
 * @example
 * ```jsx
 * const checkbox = useCheckboxState({ defaultChecked: true });
 * <Checkbox state={checkbox} />
 * ```
 */

function useCheckboxState(props) {
  var _props$defaultValue;

  if (props === void 0) {
    props = {};
  }

  var _useControlledState = useControlledState((_props$defaultValue = props.defaultValue) != null ? _props$defaultValue : false, props.value, props.setValue),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      value = _useControlledState2[0],
      setValue = _useControlledState2[1];

  var state = useMemo(function () {
    return {
      value: value,
      setValue: setValue
    };
  }, [value, setValue]);
  return state;
}

export { useCheckboxState };